module.exports = __webpack_public_path__ + "img/icon-grocery.72028728.svg";